import { render, staticRenderFns } from "./BaseSuccessModal.vue?vue&type=template&id=9795beea&"
import script from "./BaseSuccessModal.vue?vue&type=script&lang=js&"
export * from "./BaseSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports